import { TLocale } from '@aviv-estimation-funnel/shells/src/app/helpers/i18n';

const formatNumberToCurrency = (amount: number | undefined, language: TLocale = 'en') => {
    if (!amount) {
        return;
    }
    const fractionDigits = amount % 1 === 0 ? 0 : 2;
    return new Intl.NumberFormat(language, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(amount);
};

export default formatNumberToCurrency;
